<template>
  <Btn
    variant="bare"
    :title="title"
    class="center-map-on-user-btn pdgh- btn--link-dark"
    @click="pan"
  >
    <Icon
      :id="locationAvailable ? 'geolocation' : 'geolocation-unavailable'"
      :scale="1"
    />
  </Btn>
</template>

<script>
import eventBus from '@/eventBus';

export default {
  props: {
    username: {
      type: String,
      required: true,
    },
  },

  computed: {
    heartbeat() {
      return this.$store.state.live.heartbeats[this.username];
    },

    locationAvailable() {
      return this.heartbeat;
    },

    title() {
      return this.heartbeat
        ? this.$t('map.center-on-user')
        : this.$t('users.unavailable');
    },
  },

  methods: {
    heartbeatLocation(heartbeat) {
      const { latitude, longitude } = heartbeat;

      return {
        lat: latitude,
        lng: longitude,
      };
    },

    pan() {
      if (this.locationAvailable) {
        eventBus.$emit(
          'panTo',
          this.heartbeatLocation(this.heartbeat),
          true,
          this.heartbeat.username
        );
      } else {
        this.$store.dispatch('live/readHeartbeat', this.username).then(() => {
          eventBus.$emit(
            'panTo',
            this.heartbeatLocation(this.$store.state.live.lastKnownHeartbeat),
            true
          );
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.center-map-on-user-btn {
  background-color: $alt-50;
  border-left: 1px solid $alt-100;
}
</style>
